
interface SelectableChipProps {
  label: string;
  icon?: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

const SelectableChip = ({ label, icon, selected, onClick, disabled = false }: SelectableChipProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        min-h-12 min-w-0 w-full px-3 py-3 rounded-xl font-medium transition-all duration-200
        border-2 cursor-pointer
        ${selected 
          ? 'bg-[#FFD700]/10 border-[#FFD700] text-[#FFD700]' 
          : 'bg-white/5 border-white/10 text-white/90 hover:border-white/30 hover:text-white'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      `}
    >
      <div className="flex min-w-0 items-center justify-center gap-2">
        {icon && <i className={`${icon} shrink-0 text-lg`}></i>}
        <span className="min-w-0 break-words text-center">{label}</span>
      </div>
    </button>
  );
};

export default SelectableChip;
